// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"e8ad59d8","750":"a9bea6e3"}[chunkId] + ".chunk.js";
};